/* eslint-disable no-console -- Используется только в режиме дебага */
import { compact, isArray, isObject } from '@direct-frontend/stdlib';

const backgrounds = ['#363636', '#FC3F1D', '#f56788', '#15c6cf', '#faeedd'];
const colors = ['#fff', '#fff', '#fff', '#fff', '#000'];

type Tag = string | undefined;

/** параметры prettyDebugLog */
export interface DebugParameters {
    /** цветные теги для предварительного просмотра */
    tags: Tag[];
    /** html элемент, который связан с логами (для подсветки локации) */
    htmlRef?: Element | null;
    /** данные, которые будут свернуты под аккордеон */
    details?: unknown;
    /** объект с аттрибутами компонента */
    attrs?: Record<string, string>;
}

/**
 * Логирует переданные данные в красивом формате
 * @kind helper
 */
export function prettyDebugLog({ tags, details, htmlRef, attrs }: DebugParameters) {
    const filteredTags = tags.filter(Boolean);
    const tagsText = generateTags(filteredTags).join('');
    const styles = generateStyles(filteredTags);
    const header = compact([tagsText, ...styles, htmlRef, attrs]);

    if (details) {
        logCollapsed(header, details);
    } else {
        console.info(...header);
    }
}

function logCollapsed(header: unknown[], details: unknown) {
    console.groupCollapsed(...header);

    if (isArray(details)) {
        // Если записей много, то можно показать таблицу
        console.table(details);
    } else if (isObject(details) && Object.entries(details).length > 0) {
        // Если это один объект, то можно его сразу развернуть на один уровень,
        // чтобы не делать лишний клик
        Object.entries(details).forEach(([k, v]) => console.info(`%c${k}:`, 'color: #1FBEC7FF;', v));
    } else {
        // Иначе просто выводим данные как есть
        console.info(details);
    }
    console.groupEnd();
}

function generateTags(tags: Tag[]) {
    return tags.map((tag: Tag) => `%c ${tag} `);
}

function generateStyles(tags: Tag[]) {
    return tags.map((_tag, index) => generateStyle(index, tags.length));
}

function generateStyle(index: number, length: number) {
    const border = '#76c42b';
    const color = colors[index % colors.length];
    const bg = backgrounds[index % backgrounds.length];

    let style = `background-color:${bg};border-top:1px solid ${border};border-bottom:1px solid ${border};color:${color};font-size:11px;padding:2px 3px;`;

    // left
    if (!index) {
        style += 'border-top-left-radius:5px;';
        style += 'font-weight:bold;';
        style += `border-left:1px solid ${border};`;
    }

    // right
    if (index === length - 1) {
        style += 'border-bottom-right-radius:5px;';
        style += `border-right:1px solid ${border};`;
    }

    return style;
}
